import React from 'react'
import {
  CheckMark,
  InputCheckboxLabelWrapper,
  InputCheckbox
} from '../Form/Checkbox/styles'
import ErrorMessage from '../Form/ErrorMessage'
import { FormGroup, Label } from '../Form/styles'

const Checkbox = ({
  name,
  label,
  width,
  display,
  fontSizeLabel,
  overflow,
  error,
  children: _,
  ...rest
}) => {
  return (
    <FormGroup width={width} display={display}>
      <InputCheckboxLabelWrapper>
        <InputCheckbox type="checkbox" name={name} {...rest} />
        <Label fontSizeLabel={fontSizeLabel} margin="0" overflow={overflow}>
          {label}
        </Label>
        <CheckMark />
      </InputCheckboxLabelWrapper>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FormGroup>
  )
}

export default Checkbox
